import React from "react";
import { Stepper } from "react-form-stepper";
import { withRouter } from "react-router";

class ProgressStepper extends React.Component {
  
  renderProjectStep = (link) => {
    this.props.history.push({
      pathname: `/projects/${this.props.projectSlug}/${link}`,
      state: {
        challengeSlug: this.props.challengeSlug,
        goalDate: this.props.goalDate,
        adventureId: this.props.adventureId,
        projectSlug: this.props.projectSlug,
        adventureSlug: this.props.adventureSlug,
        projectUserId: this.props.projectUserId,
      },
    });
  };
  renderInvitedProjectStep = (link) => {
    this.props.history.push({
      pathname: `/projects/${this.props.projectSlug}/${link}`,
      state: {
        challengeSlug: this.props.challengeSlug,
        goalDate: this.props.goalDate,
        adventureId: this.props.adventureId,
        projectSlug: this.props.projectSlug,
        adventureSlug: this.props.adventureSlug,
        isInvite: this.props.isInvite,
        email: this.props.email,
        invitationId: this.props.invitationId,
        projectUserId: this.props.projectUserId,
      },
    });
  };
  getCurrentStep = (step) => {
    if (step === "4") return "1";
    else if (step === "0") return "0";
  };
  render() {
    return this.props.showStepper ? (
      this.props.isInvite ? (
        <Stepper
          connectorStyleConfig={{ size: 4, stepSize: "4em", style: "solid" }}
          styleConfig={{
            activeBgColor: "#2BB9B7",
            completedBgColor: "#2BB9B7",
            inactiveBgColor: "#555555",
          }}
          steps={[
            {
              label: "Step 1",
              onClick: () => {
                this.renderInvitedProjectStep("challenges");
              },
            },
            {
              label: "Step 2",
            },
            {
              label: "Step 3",
            },
          ]}
          activeStep={this.getCurrentStep(this.props.currentStep)}
        />
      ) : (
        <Stepper
          connectorStyleConfig={{ size: 4, stepSize: "4em", style: "solid" }}
          styleConfig={{
            activeBgColor: "#2BB9B7",
            completedBgColor: "#2BB9B7",
            inactiveBgColor: "#555555",
          }}
          steps={[
            {
              label: "Step 1",
              onClick: () => {
                this.renderProjectStep("challenges");
              },
            },
            {
              label: "Step 2",
              onClick: () => {
                this.renderProjectStep("start-project-step-one");
              },
            },
            {
              label: "Step 3",
              onClick: () => {
                this.renderProjectStep("start-project-step-two");
              },
            },
            {
              label: "Step 4",
              onClick: () => {
                this.renderProjectStep("start-project-step-three");
              },
            },
            {
              label: "Step 5",
              onClick: () => {
                if (this.props.link3) window.location.assign(this.props.link3);
              },
            },
          ]}
          activeStep={this.props.currentStep}
        />
      )
    ) : null;
  }
}

export default withRouter(ProgressStepper);
